module.exports = __webpack_public_path__ + "img/focus.1862e25.svg";